import React from 'react';
import { useForm } from 'react-hook-form';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  defaultValues?: any;
}

export default function Form7(props: Props) {
  const { handleSubmit } = useForm();

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Cargar Videos (NOT SAVED)</h1>

      {/* TODO: VIDEOS DE YOUTUBE */}

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
